import { useEffect, useRef, useState } from "react";
import { ReactComponent as DownArrowIcon } from "../assets/Down.svg";
import "./EntityPicker.css";

export interface Option {
  label: string;
  id: number;
}

export interface PickerProps {
  currentId: number | undefined;
  noCurrentText: string;
  noOptionsText: string;
  disabled?: boolean;
  title?: string;
  required?: boolean;
  items: Option[];
  onSelect: (id: number) => void;
}

export const EntityPicker = ({
  currentId,
  noCurrentText,
  noOptionsText,
  disabled = false,
  required = false,
  items,
  title,
  onSelect,
}: PickerProps) => {
  const getCurrent = () => {
    if (typeof currentId !== "undefined") {
      return items.find((i) => i.id === currentId);
    }
    return;
  };
  const notSelectedElement = () => {
    if (required) {
      return <span className="required-warning">{noCurrentText}</span>;
    }
    return noCurrentText;
  };
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const entityPickerListRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const listElement = entityPickerListRef.current;

    if (!listElement) return;

    listElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }, [showOptions]);

  return (
    <div className={`picker  ${disabled ? "picker-disabled" : ""}`}>
      {title && <h1>{title}</h1>}
      <button
        className="picker-button"
        disabled={disabled}
        onClick={() => {
          setShowOptions(!showOptions);
        }}
      >
        {getCurrent()?.label ?? notSelectedElement()}
        <DownArrowIcon />
      </button>
      {!disabled && showOptions && (
        <div className="picker-content" ref={entityPickerListRef}>
          {items.length ? (
            items.map((item, index) => (
              <button
                type="button"
                key={index}
                onClick={() => {
                  onSelect(item.id);
                  setShowOptions(false);
                }}
              >
                {item.label ?? noCurrentText}
              </button>
            ))
          ) : (
            <div className="picker-no-content">{noOptionsText}</div>
          )}
        </div>
      )}
    </div>
  );
};
